import React from 'react';
import Watermark from '@tv2/lib-offspring/components/watermark/Watermark';
import { Label } from '../../../../Label';
import { Link } from '../../../../Link';
import { useDeckContentSwitching } from '../../DeckContentSwitchingContext';
import {
  ArrowRightIcon,
  CardProps,
  LiveCardButtonView,
  useResolvedLiveCardContent,
} from './LiveCard';

export function LiveCardLandscape({ card, cardSize, actions }: CardProps): React.ReactNode {
  const { showNextProgram } = useDeckContentSwitching();
  const { shouldShowNextProgram, displayImageUrl, displayTitle, displayLabels, displayButton } =
    useResolvedLiveCardContent(card, showNextProgram);

  return (
    <div key={card.id}>
      <Link destination={card.destination} action={card.action} onAction={actions}>
        <div className="relative hover:scale-s 2xl:hover:scale-xs transition-transform pb-1">
          <div className="relative">
            <img
              src={displayImageUrl}
              alt={displayTitle}
              className="w-full transition-opacity duration-500"
              key={`image-${displayImageUrl}`}
            />
            <div className="absolute flex justify-center items-center pr-[40%] top-0 bottom-0 right-0 left-0">
              {card.broadcastLogoUrl && (
                <img src={card.broadcastLogoUrl} className="h-[40px]" alt="logo" />
              )}

              {displayButton ? (
                <div className="absolute inset-0">
                  <LiveCardButtonView
                    button={displayButton}
                    progress={shouldShowNextProgram ? null : (card.progress ?? null)}
                  />
                </div>
              ) : null}
            </div>
            {card.logoUrl && (
              <Watermark alt={card.title ?? ''} title={card.title ?? ''} src={card.logoUrl} />
            )}
          </div>

          {!shouldShowNextProgram && card.secondaryText ? (
            <div className="mb-2 text-marker-xs text-white">{card.secondaryText}</div>
          ) : (
            <div
              className="flex flex-row transition-opacity duration-500"
              key={`labels-${displayLabels.map(l => l.text).join('|')}`}
            >
              {displayLabels.map(label => (
                <Label key={label.text} label={label} />
              ))}
            </div>
          )}

          <div
            className={`${
              cardSize === 'SMALL' || cardSize === 'XSMALL' ? 'text-heading-xs' : 'text-heading-s'
            } mt-2 mb-0 pb-0 line-clamp-2 text-white transition-opacity duration-500`}
            key={`title-${displayTitle}`}
          >
            {displayTitle}
          </div>

          {!shouldShowNextProgram && card.subTitle ? (
            <div className="mt-2 text-neutral-400 text-marker-xs line-clamp-1 flex flex-row items-center">
              {card.subTitleIcon === 'arrow_right' && <ArrowRightIcon />}
              {card.subTitle}
            </div>
          ) : null}
        </div>
      </Link>
    </div>
  );
}
